/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseAggregatedSestAdminResponse } from '../models/ApiResponseAggregatedSestAdminResponse';
import type { ApiResponseObject } from '../models/ApiResponseObject';
import type { CreatedMaintenanceRecordAdminCommand } from '../models/CreatedMaintenanceRecordAdminCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AdminService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 교환 이력 등록
   * 교환 이력을 등록합니다.)
   * @returns ApiResponseObject OK
   * @throws ApiError
   */
  public createMaintenanceRecord2({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: CreatedMaintenanceRecordAdminCommand,
  }): CancelablePromise<ApiResponseObject> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/admin/maintenances/cars/{vin}/records',
      path: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 교환 이력 등록
   * 교환 이력을 등록합니다.)
   * @returns ApiResponseObject OK
   * @throws ApiError
   */
  public createMaintenanceRecord3({
    vin,
    requestBody,
  }: {
    vin: string,
    requestBody: CreatedMaintenanceRecordAdminCommand,
  }): CancelablePromise<ApiResponseObject> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/admin/maintenances/cars/{vin}/records/',
      path: {
        'vin': vin,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 소모품 목록 및 교환이력 조회
   * 차량의 소모품 목록 및 교환이력을 조회합니다.
   * @returns ApiResponseAggregatedSestAdminResponse OK
   * @throws ApiError
   */
  public getAggregatedSestList2({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseAggregatedSestAdminResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/admin/maintenances/cars/{vin}/sest',
      path: {
        'vin': vin,
      },
    });
  }
  /**
   * 소모품 목록 및 교환이력 조회
   * 차량의 소모품 목록 및 교환이력을 조회합니다.
   * @returns ApiResponseAggregatedSestAdminResponse OK
   * @throws ApiError
   */
  public getAggregatedSestList3({
    vin,
  }: {
    vin: string,
  }): CancelablePromise<ApiResponseAggregatedSestAdminResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/admin/maintenances/cars/{vin}/sest/',
      path: {
        'vin': vin,
      },
    });
  }
}
